import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as selfServiceActions } from "../redux/actions/selfServiceActions";
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Check, CloudUpload, Delete, NavigateNext, Photo, Refresh, Scanner, SkipNext, SystemUpdate, VerifiedUser } from "@material-ui/icons";
import SensitiveImages from "./SensitiveImages";
import PortalLoad from "../navigation/PortalLoad";


function ConfirmID(props) {
    const renderChangeDecisionOptions = () => { // I want to render this
        var verificationStatusText = '';
        switch (props.document.VerificationStatus) {
            case 'Pending':
                verificationStatusText = 'We need you to verify this document.';
                break;
            case 'ResubmissionRequested':
                verificationStatusText = 'We were unable to verify this document.';
                break;
            case 'Declined':
                verificationStatusText = 'This document is not valid.';
                break;
            case 'Verified':
                verificationStatusText = 'This document is verified.';
                break;
            default:
                break;
        }

        var userDecisionText = '';
        switch (props.document.UserDecision) {
            case 'New':
            case 'Uploaded':
            case 'Confirmed':
                userDecisionText = 'You confirmed that the document is correct.';
                break;
            case 'Removed':
                userDecisionText = 'You marked the document for removal.';
                break;
            default:
                break;
        }

        return (<Alert severity="info">{verificationStatusText} {userDecisionText} Click <b onClick={(e) => { e.preventDefault(); props.changeDecision(); }} style={{ cursor: 'pointer' }}>here</b> to change your decision.</Alert>);
    };

    return (
        <div>
            {props.document && <Box sx={{
                borderRadius: 0,
                p: 5, width: '100%', minWidth: 500,
                '& .MuiTextField-root': {
                    margin: '25px', width: '25%'
                },
                '& .MuiButtonBase-root': {
                    marginLeft: '25px'
                }
            }}
                component="form"
                noValidate
                autoComplete="off"
            >
                <Typography sx={{ margin: '10px', textAlign: 'center' }} variant="h6">Document Verification</Typography>
                {(!props.document.UserDecision || props.document.UserDecision === 'Skipped' || props.document.VerificationStatus === 'Declined') && <>
                    {props.document.VerificationStatus === 'Review' && <Alert severity="info">This document is currently being verified.</Alert>}
                    {props.document.VerificationStatus === 'Pending' && <Alert severity="info">We need you to verify this document.</Alert>}
                    {props.document.VerificationStatus === 'Verified' && <Alert severity="info">Please confirm that the document we have on file is correct.</Alert>}
                    {props.document.VerificationStatus === 'ResubmissionRequested' && <Alert severity="warning">We were unable to verify your document. Please try verify it again.</Alert>}
                    {props.document.VerificationStatus === 'Declined' && <Alert severity="error">Document is not valid. Please remove it to continue.</Alert>}
                </>}
                {props.document.UserDecision && props.document.UserDecision !== 'Skipped' && props.document.VerificationStatus !== 'Declined' && <>
                    {renderChangeDecisionOptions()}
                </>}
                <div>
                    <TextField sx={{ m: 2 }}
                        id="outlined-read-only-input"
                        label="Document Type"
                        value={props.document.DocumentTypeName || ''}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <TextField
                        id="outlined-read-only-input"
                        label="ID Number"
                        value={props.document.DocumentID || ''}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <TextField
                        id="outlined-read-only-input"
                        label="Country of Issue"
                        value={props.document.IssuingCountry || ''}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </div>

                <SensitiveImages {...props} />

                {(!props.document.UserDecision || props.document.UserDecision === 'Skipped' || props.document.VerificationStatus === 'Declined') &&
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            {(props.document.VerificationStatus === 'ResubmissionRequested') &&
                                (
                                    <>
                                        <Button type="submit" variant='contained' color='primary' startIcon={<Refresh />} onClick={(e) => { e.preventDefault(); props.upload(); }} title='Retry'>Retry Upload</Button>
                                        <Button type="submit" variant='contained' color='secondary' startIcon={<SkipNext />} onClick={(e) => { e.preventDefault(); props.skip(); }} title='Skip For Now'>Skip For Now</Button>
                                    </>
                                )}
                            {(props.document.VerificationStatus === 'Pending') &&
                                (<>
                                    <Button type="submit" variant='contained' color='secondary' startIcon={<SkipNext />} onClick={(e) => { e.preventDefault(); props.skip(); }} title='Skip For Now'>Skip For Now</Button>
                                    <Button type="submit" variant='contained' color='primary' startIcon={<VerifiedUser />} onClick={(e) => { e.preventDefault(); props.upload(); }} title='Verify Now'>Verify Now</Button>
                                </>
                                )
                            }
                        </Grid>

                        <Grid item>
                            {props.document.VerificationStatus !== 'Review' && <Button variant='outlined' startIcon={<Delete />} style={{ color: 'tomato', borderColor: 'tomato' }} onClick={(e) => { e.preventDefault(); props.remove(props.document); }} title='Remove'>Remove</Button>}
                            {(props.document.VerificationStatus === 'Verified' || props.document.VerificationStatus === 'Review') &&
                                <Button type="submit" variant='contained' color='primary' startIcon={<Check />} onClick={(e) => { e.preventDefault(); props.confirm(); }} title='Confirm'>Confirm</Button>
                            }
                        </Grid>
                    </Grid>
                }

                {props.document.UserDecision && props.document.UserDecision !== 'Skipped' && props.document.VerificationStatus !== 'Declined' &&
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Button type="submit" variant='contained' color='primary' startIcon={<NavigateNext />} onClick={(e) => { e.preventDefault(); props.next(); }} title='Next'>Next</Button>
                        </Grid>
                    </Grid>
                }
                {props.loading && <PortalLoad />}
                {props.errored && <><br /><span style={{ color: 'tomato' }}>There was an error trying to start the verification process. Please contact your administrator.</span></>}
            </Box>}
        </div>
    );
}


export default connect(
    (state) => state.selfService,
    (dispatch) => bindActionCreators(selfServiceActions, dispatch)
)(ConfirmID);
